import React from 'react';
import { useSelector } from 'react-redux';

const STATUS_MESSAGES = {
    loading: 'Loading child codes…',
    empty: 'No child codes found.',
    error: 'Failed to load child codes. Collapse and expand to retry.',
};

// Always-present columns (Row, Category, Is Code Bundle, Code, Description, LSP, Location, TTM,
// Mappings, Actions). colSpan must match the real column count exactly — the table is
// `table-layout: fixed`, so an over-large colSpan models phantom columns and squeezes the real ones.
const BASE_COLUMN_COUNT = 10;

// Loading / empty / error row shown inside an expanded bundle panel.
const BundleChildStatusRow = ({ status }) => {
    const practiceIsFinalized = useSelector((state) => state.daylight.practiceIsFinalized);
    const displayUsageDetails = useSelector((state) => state.daylight.userHasAccessToCodeUsageDetails);

    const columnCount =
        BASE_COLUMN_COUNT + (practiceIsFinalized ? 0 : 1) + (displayUsageDetails ? 1 : 0);

    return (
        <tr className="border-dark bundle-child-row bundle-child-status">
            <td
                colSpan={columnCount}
                className={`py-3 text-center font-italic${status === 'error' ? ' text-danger' : ' text-muted'}`}>
                {STATUS_MESSAGES[status] ?? STATUS_MESSAGES.loading}
            </td>
        </tr>
    );
};

export default BundleChildStatusRow;
